
import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { ChartDataSets, ChartOptions, ChartType } from 'chart.js';
import { Label } from 'ng2-charts';
import { catchError, debounceTime, filter, map, startWith, switchMap } from 'rxjs/operators';
import { ResponseUSer } from 'src/app/_models';
import { AuthenticationService, ViewPendingOrderGraficaService, ViewTodayOrdersService, ViewYearlyOrderGraficaService } from 'src/app/_services';
import { fromEvent, merge, of as observableOf } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { NgxSpinnerService } from 'ngx-spinner';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css'],
})
export class HomeComponent implements OnInit,AfterViewInit,OnDestroy {

  SearchDatabase: ViewPendingOrderGraficaService | null;
  SearchDatabaseyearly: ViewYearlyOrderGraficaService | null;
  SearchDatabaseToday: ViewTodayOrdersService | null;
  currentUser: ResponseUSer;
  viewSelect=false;
  barChartOptions: ChartOptions = {
    responsive: true,
  
  };
  barChartLabels: Label[] = [
    'Order'
  ];
  barChartType: ChartType = 'bar';
  barChartLegend = false;
  barChartPlugins = [];
  multipleCustomers=[];
  barChartData: ChartDataSets[] = [];
  yearly: ChartDataSets[] = [];
  Today: ChartDataSets[] = [];
graficas=false;
mySubscription: any;
idcustomer=0;
  constructor(
    private router: Router,
    private authenticationService: AuthenticationService,
    private _httpClient: HttpClient,
    private spinner: NgxSpinnerService
    
  ) {
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((events) => {
      this.authenticationService.currentUser.subscribe(x => this.currentUser = x);


    });
     this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    };
    this.mySubscription = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        console.log("ddddd")
        // Trick the Router into believing it's last link wasn't previously loaded
        this.router.navigated = true;
      }
    })
    var json = JSON.parse(localStorage.getItem('currentUser')); //json con datos de usuario
this.multipleCustomers=[];
 
   
  }
  ngOnDestroy(): void {
    
    if (this.mySubscription) {
      
      this.mySubscription.unsubscribe();
     
    }
    var element = document.getElementById('SubMenu');
    element.style.display = 'none';
  
    localStorage.setItem('header', '0');

  }
  ngAfterViewInit(): void {
    this.spinner.show();
 
    setTimeout(() => {
      /** spinner ends after 5 seconds */
      this.spinner.hide();
    }, 500);
    const main =  <HTMLInputElement>document.getElementById('SubMenu');


    fromEvent(main, 'mouseenter')
    .pipe(   
      switchMap(event => {
        console.log('show');
        main.style.display = 'block';
        return fromEvent(main, 'mouseleave').pipe(debounceTime(500));
      })
      )
    .subscribe(val => {
     console.log('hide');
     main.style.display = 'none';
   });
  }

  ngOnInit(): void {
    
    if (this.authenticationService.currentUserValue) {
      if(this.authenticationService.currentUserValue.rol=="AdministradorEmpresa"){
        this.graficas=true;
      this.OnpendingOrders();
      this.OnYearlyOrders();
      this.OnTodayOrders();
      this.viewSelect=false;
      }else{
        this.graficas=false;
        this.viewSelect=true;
        this.idcustomer=Number(this.authenticationService.currentUserValue.customerId);
        this.OnSelectCustomerMultiple();  
      }
      var element = document.getElementById('fondo');
      element.classList.remove('fondo');
    }
    
  }

  OnpendingOrders() {
    
    
    
    this.SearchDatabase = new ViewPendingOrderGraficaService(this._httpClient);
    
    
    merge()
      .pipe(
        startWith({}),
        switchMap(() => {
     
          return this.SearchDatabase!.getRepoIssues(
            this.authenticationService.currentUserValue.companyIdWh,
            this.authenticationService.currentUserValue.token
          );
        }),
        map((data) => {
        

          return data;
        }),
        catchError(() => {

          return observableOf([]);
        })
      )
      .subscribe((datas) => {
       this.barChartData=datas;
       
      });
  }
  OnYearlyOrders() {
    
    
    
    this.SearchDatabaseyearly = new ViewYearlyOrderGraficaService(this._httpClient);
    
    
    merge()
      .pipe(
        startWith({}),
        switchMap(() => {
     
          return this.SearchDatabaseyearly!.getRepoIssues(
            this.authenticationService.currentUserValue.companyIdWh,
            this.authenticationService.currentUserValue.token
          );
        }),
        map((data) => {
        

          return data;
        }),
        catchError(() => {

          return observableOf([]);
        })
      )
      .subscribe((datas) => {
       this.yearly=datas;
      });
  }
  OnTodayOrders() {
    
    
    
    this.SearchDatabaseToday = new ViewTodayOrdersService(this._httpClient);
    
    
    merge()
      .pipe(
        startWith({}),
        switchMap(() => {
     
          return this.SearchDatabaseToday!.getRepoIssues(
            this.authenticationService.currentUserValue.companyIdWh,
            this.authenticationService.currentUserValue.token
          );
        }),
        map((data) => {
        

          return data;
        }),
        catchError(() => {

          return observableOf([]);
        })
      )
      .subscribe((datas) => {
       this.Today=datas;
      });
  }
  OnSelectCustomerMultiple(){

    var json = JSON.parse(localStorage.getItem('currentUser')) //json con datos de usuario

    var Request = {}
    Request['tblUsersAccounts'] = json.id
    Request['active'] = 1 

   try {
    this._httpClient
    .get<any>(`${environment.apiUrl}/TblUsersAccountsMultipleCustomers/TblUsersAccountsMultipleCustomers_Select?tblUsersAccounts=${json.id}&active=1`, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Headers': '*',
        'Access-Control-Allow-Methods': '*',
        Authorization: 'Bearer ' + json.token
      })
    })
    .subscribe((response: any) => {
      this.multipleCustomers = JSON.parse(response)
      localStorage.setItem('multipleCustomers', JSON.stringify(this.multipleCustomers));
      
    })
   } catch (error) {
    
   }  

  }
  OnChangeNewCustomer(data: any) {
console.log(data);

this.authenticationService.currentUserValue.customerId=String(data);
localStorage.setItem('currentUser', JSON.stringify(this.authenticationService.currentUserValue));
//localStorage.setItem('currentUserTokenApi', JSON.stringify(token));
this.authenticationService.currentUserSubject.next(this.authenticationService.currentUserValue);

  }
  
}
